import React from "react";
import HeaderLogin from "./../HeaderLogin/HeaderLogin.jsx";
import { Button, Card, Col, Form, Row, Tabs, Tab } from "react-bootstrap";
import { getAllSubscriptionAction } from "./../../actions/SubscriptionAction";
import * as code from "./../../config/Constants";
import { connect } from "react-redux";
import { currencyFormat } from "./../Common/Common";
import noRecord from "./../../assets/img/no-record.png";

class Pricing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthData: [],
      yearData: [],
      showLoader: false,
    };
  }
  componentWillMount() {
    this.setState({ showLoader: true });
    // this.props.getAllSubscriptionAction("month").then(monthRes => {
    //     this.setState({ showLoader: false });
    //     if (monthRes.status === code.OK) {
    //         this.setState({ monthData: monthRes.data });
    //     }
    // });
    // this.props.getAllSubscriptionAction("year").then(yearRes => {
    //     this.setState({ showLoader: false });
    //     if (yearRes.status === code.OK) {
    //         this.setState({ yearData: yearRes.data });
    //     }
    // })
  }
  goToSignUp(id, interval) {
    this.props.history.push({
      pathname: "/register",
      fromPricing: true,
    });
    localStorage.setItem("price", id);
    localStorage.setItem("interval", interval);
  }
  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="container-custom pricing">
              <Tabs
                defaultActiveKey="monthly"
                id="uncontrolled-tab-example"
                className="subscription-tabs"
                onSelect={this.handleSelect}
              >
                <Tab eventKey="monthly" title="Monthly">
                  {this.state.monthData.length > 0 ? (
                    <Row>
                      {this.state.monthData.map((monthData) => {
                        if (monthData.price.isActive && monthData.isActive) {
                          let description =
                            "<div>" + monthData.description + "</div>";

                          return (
                            <Col lg={3} md={6} sm={6} className="plan-scheme">
                              <Card className="transaction-single">
                                <Card.Body>
                                  <h4>{monthData.name}</h4>
                                  <p className="plan-price">
                                    {currencyFormat(
                                      monthData.price.unit_amount
                                    )}
                                    /mo.
                                  </p>
                                  <div className="plan-desc">
                                    <label>Description</label>
                                    <p
                                      className="plan-text"
                                      dangerouslySetInnerHTML={{
                                        __html: monthData.description,
                                      }}
                                    />
                                    <div
                                      className="more-plan-text"
                                      dangerouslySetInnerHTML={{
                                        __html: description,
                                      }}
                                    />
                                  </div>
                                  <Button
                                    variant="primary"
                                    className="btn-blue w-140"
                                    onClick={() =>
                                      this.goToSignUp(
                                        monthData.price.price,
                                        monthData.price.recurring.interval
                                      )
                                    }
                                  >
                                    SIGN UP NOW
                                  </Button>
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  ) : (
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No Plans Found</p>
                      </div>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="annually" title="Annually">
                  {this.state.yearData.length > 0 ? (
                    <Row>
                      {this.state.yearData.map((yearData) => {
                        if (yearData.price.isActive && yearData.isActive) {
                          let description =
                            "<div>" + yearData.description + "</div>";

                          return (
                            <Col lg={3} md={6} sm={6} className="plan-scheme">
                              <Card className="transaction-single">
                                <Card.Body>
                                  <h4>{yearData.name}</h4>
                                  <p className="plan-price">
                                    {currencyFormat(yearData.price.unit_amount)}
                                    /yr.
                                  </p>
                                  <div className="plan-desc">
                                    <label>Description</label>
                                    <p
                                      className="plan-text"
                                      dangerouslySetInnerHTML={{
                                        __html: yearData.description,
                                      }}
                                    />
                                    <div
                                      className="more-plan-text"
                                      dangerouslySetInnerHTML={{
                                        __html: description,
                                      }}
                                    />
                                  </div>
                                  <Button
                                    variant="primary"
                                    className="btn-blue w-140"
                                    onClick={() =>
                                      this.goToSignUp(
                                        yearData.price.price,
                                        yearData.price.recurring.interval
                                      )
                                    }
                                  >
                                    SIGN UP NOW
                                  </Button>
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  ) : (
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No Plans Found</p>
                      </div>
                    </div>
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {};
export default connect(
  mapStateToProps,
  {
    getAllSubscriptionAction,
  }
)(Pricing);
